<template lang="pug">
  include ./../../mixins
  +b.quote
    +b.preloader(v-if="loading")
      +e.item
    +e.title
      +b.P.caption.--size_2 {{ _("Quick Quote") }}
    validation-observer(
      tag="form"
      ref="observer"
      v-slot="props"
      @submit.prevent="validateBeforeSubmit"
    )
      +b.ug-row.--offset_sm
        +b.ug-cell.ug-cols
          validation-provider(
            tag="div"
            v-slot="{errors}"
            rules="required"
            name="car_registration"
          )
            ui-input(
              v-model='formdata.car_registration',
              type='text',
              :errors="errors"
              :label='_("Car registration number")'
            )
        +b.ug-cell.ug-cols
          +b.input-wrapper
            +e.field
              validation-provider(
                tag="div"
                v-slot="{errors}"
                rules="required"
                name="post_code"
              )
                ui-input(
                  v-model='formdata.post_code',
                  type='text',
                  :errors="errors"
                  :label='_("Postal code")'
                )
            +e.icon
              toggle-mixin-modal(
                :component-name="'GoogleMapModal'"
                :modal-class="'cabinet-modal--size_full'"
              )
                template(#default="{handler}")
                  +b.I.icon.--type_marker(
                    @click.prevent="handler"
                  )
        +b.ug-cell.ug-cols
          validation-provider(
            tag="div"
            v-slot="{errors}"
            rules="required"
            name="service"
          )
            +b.control
              +e.elements
                select.control-input(
                  v-model= "formdata.service"
                  v-if="windowWidth < 1200"
                )
                  option(value="") {{ _("Choose a service you need") }}
                  option(v-for="item in services" :value="item.id") {{ item.title }}
                multiselect(
                  v-if="windowWidth >= 1200"
                  :options= "services",
                  label='title',
                  placeholder=""
                  open-direction="bottom"
                  v-model= "formdata.service"
                  :searchable= "false",
                  :class="{'is-error': errors[0], 'multiselect--relative': isModal}"
                  :show-labels= "false"
                )
                  template(slot='caret')
                    +e.icon
                      +b.I.icon.--type_dropdown
                +e.label(
                  :class='{"is-active": formdata.service}'
                  v-if="windowWidth >= 1200"
                )
                  label {{ _("Choose a service you need") }}
              +e.meta(v-if="errors[0]")
                +e.help
                  +b.SPAN.help.--type_error(:class='{"is-error": errors[0]}') {{ errors[0] }}
        +b.ug-cell.ug-cols(v-if="isPhoneMechanic")
          validation-provider(
            tag="div"
            v-slot="{errors}"
            :rules="'required|ukPhone'"
            name="phone"
          )
            ui-input(
              v-model.trim='formdata.phone',
              name="phone"
              type='tel',
              :errors="errors"
              :label='_("Phone number")'
            )
        +b.ug-cell.ug-cols
          +b.A.button(@click.prevent="validateBeforeSubmit") {{ _("Get price now") }}
</template>

<script>
import mixinValidate from '@/js/mixins/formValidate'
import mixinErrors from '@/js/mixins/showErrors'
import InfoModal from '@/js/components/Modals/InfoModal'
import OrderFail from '@/js/components/Modals/OrderFail'
import OrderConfirm from '@/js/components/Modals/Order'
import {
  eventBus,
} from '@/js/eventBus'

export default {
  props: {
    url: String,
    servicesUrl: String,
    unregisteredOrderUrl: String,
    isModal: {
      default: false
    },
    isPhoneMechanic: {
      type: Boolean
    },
    serviceId: {},
  },
  mixins: [
    mixinValidate,
    mixinErrors,
  ],
  data() {
    return {
      services: [],
      loading: false,
      windowWidth: window.innerWidth,
      formdata: {
        'post_code': '',
        service: '',
        phone: '',
      },
    }
  },
  mounted() {
    eventBus.$on('postcode:update', data => {
      this.setPostCodeHandler(data)
    })
    this.getServices()
  },
  methods: {
    getLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(this.showPosition)
      } else {
        this.showZipNotFoundModal()
      }
    },
    showZipNotFoundModal() {
      this.$modal.show(InfoModal, {
        title: this._("Sorry, but Geolocation is not supported by this browser."),
      }, {
        height: 'auto',
        transition: "nice-modal-fade",
        clickToClose: false,
        scrollable: true
      })
    },
    setPostCodeHandler(code) {
      this.formdata['post_code'] = code
    },
    showPosition(position) {
      let lat = position.coords.latitude
      let long = position.coords.longitude
      let key = window.googleApiKey
      let url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${long}&key=${key}`
      axios.get(url).then(res => {
        let results = res.data.results
        let addressComponents = results[0]['address_components']
        addressComponents.forEach(el => {
          if (el.types.includes('postal_code')) {
            this.formdata['post_code'] = el['long_name']
          }
        })
      })
    },
    getServices() {
      this.api.get(this.servicesUrl).then(res => {
        let {data} = res
        this.services = data
        this.preselectService()
      })
    },
    preselectService() {
      const preselectedService = this.services
        .find(el => el.id === Number(this.serviceId))
      if (preselectedService) {
        const xl = 1200
        if (this.windowWidth >= xl) {
          this.formdata.service = preselectedService
        } else {
          this.formdata.service = preselectedService.id
        }
      }
    },
    send() {
      this.loading = true
      let formdata = JSON.parse(JSON.stringify(this.formdata))
      if (this.isPhoneMechanic) {
        const trimed = formdata.phone.replace(/[- )(]/g, '')
        formdata.phone = trimed
      }
      if (formdata.service.hasOwnProperty('id')) {
        formdata.service = formdata.service.id
      }
      this.api.post(this.url, formdata).then(res => {
        let {data} = res
        this.loading = false
        this.emitClose()
        if (this.isPhoneMechanic) {
          this.responseModal({title: this._("Your request is approved, we sent you a message."), subtitle: this._("Check your phone, please.")})
        } else {
          this.openOrderConfirmModal(data)
        }
        this.clearForm()
      }).catch(error => {
        this.loading = false
        if (this.isPhoneMechanic) {
          this.responseModal({title: this._("Unfortunately, we didn't find your car in our date base. Our manager will contact you as soon as possible.")})
        } else {
          this.openOrderFailModal()
        }
        this.clearForm()
      })
    },
    clearForm() {
      Object.keys(this.formdata).forEach(key => {
        this.formdata[key] = ''
      })
      const timeout = 100
      setTimeout(() => {
        this.$refs.observer.reset()
      }, timeout)
    },
    openOrderConfirmModal(data) {
      let formdata = JSON.parse(JSON.stringify(this.formdata))
      let serviceName = ''
      if (formdata.service.hasOwnProperty('id')) {
        serviceName = formdata.service.title
        formdata.service = formdata.service.id
      } else {
        this.services.forEach(el => {
          if (el.id == formdata.service) {
            serviceName = el.title
          }
        })
      }
      this.$modal.show(OrderConfirm, {
        url: this.unregisteredOrderUrl,
        quoteInfo: formdata,
        orderIno: data,
        serviceName: serviceName
      }, {
        height: 'auto',
        transition: "nice-modal-fade",
        clickToClose: false,
        scrollable: true
      })
    },
    openOrderFailModal() {
      let formdata = JSON.parse(JSON.stringify(this.formdata))
      if (formdata.service.hasOwnProperty('id')) {
        formdata.service = formdata.service.id
      }
      this.$modal.show(OrderFail, {
        url: this.unregisteredOrderUrl,
        quoteInfo: formdata,
      }, {
        height: 'auto',
        transition: "nice-modal-fade",
        clickToClose: false,
        scrollable: true
      })
    },
    emitClose() {
      this.$emit('close')
    },
    responseModal(message) {
      this.$modal.show(InfoModal, {
        title: message.title,
        subtitle: message.subtitle,
      }, {
        height: 'auto',
        transition: "nice-modal-fade",
        clickToClose: false,
        scrollable: true
      })
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/js/components/Forms/Quote.vue